<template>
  <div class="container">
    <van-image width="100%" :src="detailDataList.coverImage" />
    <section class="page-title">
      <van-image :src="require('@/assets/culturalRelic/baoming.png')" />
      <p>{{detailDataList.name}}</p>
    </section>
    <section class="page-body">
      <van-image class="pattern" :src="require('@/assets/culturalRelic/wen@2x.png')" />
      {{detailDataList.introduce}}具体情况如下：
      <section class="section">
        <h4>活动时间：</h4>
        <div style="margin: 0;word-break:break-all;">{{detailDataList.activityTime}}</div>
      </section>
      <section class="section">
        <h4>活动地点：</h4>
        {{detailDataList.location}}
      </section>
      <section class="section">
        <h4>鉴定门类：</h4>
        {{detailDataList.appraisalCategory}}
      </section>
      <section class="section">
        <h4>咨询电话：</h4>
        {{detailDataList.consultationPhone}}
      </section>
      <section class="detail">
        <h4>报名详情：</h4>
        <div class="content" v-html="detailDataList.registrationDetail"></div>
      </section>
      <van-image width="100%" class="pattern-bottom" :src="require('@/assets/culturalRelic/wen-di@2x.png')" />
    </section>
    <van-button text="点击报名" color="#BF6A55" @click="detailClick"/>
  </div>
</template>

<script>
import { getActivityQueryById, getActivityStatusById } from '@/api/culturalRelic'
export default {
  name: 'CulturalRelicSignUpNotice',
  data: () => ({
    detail: '<p>hello world</p>',
    detailDataList: ''
  }),
  mounted () {
    this.detailData()
  },
  methods: {
    async detailClick () {
      const id = this.$route.params.id
      const result = await getActivityStatusById(id)
      console.log(result)
      this.$router.replace(`/culturalRelic/signUp/${this.$route.params.id}`)
    },
    async detailData () {
      const res = await getActivityQueryById(this.$route.params.id)
      console.log(res)
      sessionStorage.setItem('appointment', res.result.appointmentNotice)
      sessionStorage.setItem('time', res.result.endTime)
      this.detailDataList = res.result
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #F7EEE8;
  overflow: hidden;
  .page-title {
    margin: 0 12px;
    background: #F3E6DD;
    box-shadow: 0 0 10px 0 rgba(110, 99, 93, .3);
    border-radius: 6px;
    padding: 20px 12px;
    box-sizing: border-box;
    position: relative;
    top: -14px;
    z-index: 2;
    font-family:'PingFangMedium';
    .van-image {
      width: 108px;
    }
    p {
      font-size: 14px;
      text-align: center;
    }
  }
  .page-body {
    min-height: 80vh;
    margin: 0 12px;
    margin-bottom: 20px;
    background: #F3E6DD;
    box-shadow: 0px 0px 10px 0px rgba(110, 99, 93, 0.3);
    border-radius: 7px;
    padding: 16px 14px;
    box-sizing: border-box;
    color: #312925;
    line-height: 1.7;
    position: relative;
    font-size: 14px;
    //font-family:'PingFangMedium';
    h4 {
      margin: 0;
      margin-top: 20px;
      font-size: 15px;
    }
    .pattern {
      width: 242px;
      position: absolute;
      right: -12px;
      top: -25px;
      z-index: 2;
    }
    .pattern-bottom {
      position: absolute;
      bottom: 0;
    }
  }
  ::v-deep .van-button {
    font-size: 16px;
    display: block;
    height: 33px;
    margin: 26px auto;
    border-radius: 4px;
    padding: 8px 30px;
    .van-button__text {
      color: #eee;
    }
  }
}
</style>
